import React from 'react'
import classnames from 'classnames'
import { compose, lifecycle, withProps } from 'recompose'
import styled from 'styled-components'

const Nav = styled.nav`
  border-bottom: 1px solid rgba(0, 0, 0, 0.0975);
`

const NavBar = ({ isFixedTop, isWidthContained, children }) => (
  <Nav
    className={classnames('navbar', {
      'is-fixed-top': isFixedTop,
    })}
  >
    <NavBarContainer>{children}</NavBarContainer>
  </Nav>
)

const NavBarContainer = styled.div.attrs({ className: 'container' })`
  display: flex !important;
`

export default compose(
  withProps(props => ({
    isFixedTop: props.isFixedTop | false,
    isWidthContained: props.isWidthContained | false,
    isButtomBorder: props.isButtomBorder | false,
  })),
  lifecycle({
    componentDidMount() {
      const className = document.querySelector('body').className
      const { isFixedTop } = this.props
      document.querySelector('body').className = classnames(className, {
        'has-navbar-fixed-top': isFixedTop,
      })
    },
  }),
)(NavBar)



// WEBPACK FOOTER //
// ./src/components/views/navbar/NavBar.js